<template>
	<v-container fluid>
	

		<v-row class="padMob" style="padding: 50px">
			<v-col cols="12" md="6" class="d-flex flexMobile">
				<v-img
					v-if="parceiro.photo != null"
					contain
					width="150"
					height="150"
					class="sizeMob"
					style="border-radius: 50% !important"
					:src="`${$root.$publicUrl}/files/load-image/150/150/${
						parceiro.photo.id
					}/${sanitizeTitle(parceiro.photo.name)}.${parceiro.photo.extension}`"
				>
				</v-img>
				<v-img
					v-if="parceiro.photo == null"
					contain
					width="150"
					height="150"
					class="sizeMob"
					style="border-radius: 50% !important"
					src="../assets/imagePlaceHolder.jpeg"
				>
				</v-img>

				<div>
					<h2
						style="
							padding: 0px;
							font-family: raleway;
							color: #042d4c;
							font-weight: 700;
						"
					>
						{{ parceiro.name }}
					</h2>
					<p style="font-family: raleway; font-weight: 300; color: #042d4c">
						<small v-for="(c, i) in parceiro.category_user_rels" :key="c.id">
							<span v-if="i > 0">•</span>
							{{ c.category.name }}
						</small>
					</p>
					<div
						style="margin-right: 15px"
						class="etiqueta d-flex justify-center align-center"
					>
						<span style="color: #042d4c"
							>até
							<span
								>{{
									parceiro.infos !== null
										? parceiro.infos.accepted_tokens_percentual
										: `0`
								}}%</span
							>
							em Ribus Token</span
						>
					</div>
				</div>
			</v-col>
			<v-col cols="12" md="6" class="flex-column d-flex justify-center">
				<h2
					style="
						padding: 0px;
						font-family: raleway;
						color: #042d4c;
						font-weight: 700;
					"
				>
					Acompanhe nosso parceiro em suas redes sociais
				</h2>

				<div v-if="haveSocialMedia">
					<v-row
						align="center"
						v-if="haveSocialMedia"
						style="margin-top: 5px; padding-left: 8px"
					>
						<a
							target="_blank"
							v-if="parceiro.infos.social.ig"
							:href="getInstagram"
						>
							<v-icon large class="socialIcons" color="orange darken-2">
								mdi-instagram
							</v-icon>
						</a>
						<a
							target="_blank"
							v-if="parceiro.infos.social.fb"
							:href="parceiro.infos.social.fb"
						>
							<v-icon large class="socialIcons" color="orange darken-2"
								>mdi-facebook</v-icon
							>
						</a>
						<a
							target="_blank"
							v-if="parceiro.infos.social.linkedin"
							:href="parceiro.infos.social.linkedin"
						>
							<v-icon large class="socialIcons" color="orange darken-2"
								>mdi-linkedin</v-icon
							>
						</a>
					</v-row>
				</div>

				<!-- <v-card-actions class="" style="padding: 20px 0">
					<router-link to="/beneficiusDescriImovel">
						<v-btn
							style="
								border: 1px solid #fe9a29;
								color: #fe9a29;
								box-shadow: none;
								background-color: transparent;
							"
						>
							Entrar em contato
						</v-btn>
					</router-link>
				</v-card-actions> -->

				<v-card-actions class="" style="padding: 20px 0">
					<a :href="`https://wa.me/${parceiro.phone}`" target="_blank">
						<v-btn
							style="
								border: 1px solid #fe9a29;
								color: #fe9a29;
								box-shadow: none;
								background-color: transparent;
							"
						>
						<v-icon color="#fe9a29;">mdi-phone</v-icon>
							Entrar em contato
						</v-btn>
					</a>
				</v-card-actions>
			</v-col>
		</v-row>

		<v-row class="padMob" style="padding: 50px">
			<v-col cols="12" md="12">
				<h2
					style="
						padding: 0px;
						font-family: raleway;
						color: #042d4c;
						font-weight: 700;
					"
				>
					Sobre:
				</h2>

				<p
					class="mt-10"
					style="font-family: raleway; font-weight: 400; color: #042d4c"
				>
					{{ parceiro.description }}
				</p>
			</v-col>

			<v-col cols="12" md="6">
				<h2
					style="
						padding: 0px;
						font-family: raleway;
						color: #042d4c;
						font-weight: 700;
					"
				>
					Onde ficamos
				</h2>

				<iframe
					v-if="parceiro.address !== null"
					:src="`https://www.google.com/maps?output=embed&amp;q=${parceiro.address.street}${parceiro.address.number} - ${parceiro.address.city}&amp;z=16&amp;t=m`"
					width="100%"
					height="200"
					style="border: 0"
					allowfullscreen=""
					loading="lazy"
					referrerpolicy="no-referrer-when-downgrade"
				></iframe>
				<div class="d-flex">
					<p style="font-family: raleway; font-weight: 400; color: #042d4c">
						R. da Quitanda, 60 - Centro Rio de Janeiro - RJ
					</p>
				</div>
			</v-col>
			<v-col cols="12" md="6">
				<!-- <h2
					style="
						padding: 0px;
						font-family: raleway;
						color: #042d4c;
						font-weight: 700;
					"
				>
					Contatos:
				</h2>
				<v-list dense>
					<v-list-item-group color="primary">
						<v-list-item v-for="(item3, i) in items3" :key="i">
							<v-list-item-icon>
								<v-icon color="#FE9A29" v-text="item3.icon"></v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title
									style="
										padding: 0px;
										font-family: raleway;
										color: #042d4c;
										font-weight: 600;
									"
									v-text="item3.text"
								></v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list-item-group>
				</v-list> -->
			</v-col>
		</v-row>

		<v-row class="padMob" style="margin-top: 0px; padding: 50px">
			<v-col cols="12" md="12">
				<h2 style="color: #050f16; font-size: 18px; font-weight: 500">
					Serviços e produtos oferecidos
				</h2>
				<!-- <p style="margin-bottom: 0px !important;">Lorem ipsum dolor sit amet consectetur adipisicing elit,
                  reprehenderit reiciendis quas dolore quod sapiente.</p> -->
			</v-col>

			<v-col cols="12" md="12">
				<v-row
					class="padTab"
					style="
						margin-top: 0px;
						border-radius: 20px;
						border: 1px solid #bfbfbf;
						padding: 20px;
					"
				>
					<v-tabs grow v-model="tab" align-with-title>
						<v-tabs-slider color="orange"></v-tabs-slider>
						<v-tab style="color: #000" v-for="item in items" :key="item">
							{{ item }}
						</v-tab>
					</v-tabs>
					<v-tabs-items v-model="tab" style="">
						<v-tab-item>
							<v-row>
								<CardImovel
									v-for="p in produtos"
									:key="p.id"
									:imovel="p"
									:categoria="`imoveis`"
								></CardImovel>
							</v-row>
						</v-tab-item>

						<v-tab-item>
							<v-row>
								<v-img src="../assets/gif.gif" width="300"></v-img>
							</v-row>
						</v-tab-item>

						<v-tab-item style="width: 100% !important">
							<v-row>
								<v-col v-for="s in servicos" :key="s.id">
									<v-card max-width="300" class="mx-auto" outlined>
										<v-carousel
											hide-delimiter-background
											dark
											delimiter-icon="mdi-minus"
											style="height: 221px"
											light
											id="cases"
											class="d-flex justify-center flex-column pt5"
											v-if="s.files.length > 0"
										>
											<template v-slot:prev="{ on, attrs }">
												<v-icon v-on="on" v-bind="attrs" color="white"
													>mdi-arrow-left</v-icon
												>
											</template>
											<template v-slot:next="{ on, attrs }">
												<v-icon v-on="on" v-bind="attrs" color="white"
													>mdi-arrow-right</v-icon
												>
											</template>

											<v-carousel-item v-for="(img, i) in s.files" :key="i">
												<v-sheet tile style="background-color: transparent">
													<v-row align="center">
														<v-col cols="12" md="12">
															<!-- <v-img width="100%" height="221px" max-height="221px" v-if="img.file_storage != undefined" :src="`${$root.$publicUrl}/files/load-full-image/${img.file_storage.id}/${$root.$options.filters.sanitizeTitle(img.file_storage.name)}
                                    .${img.file_storage.extension}`">
                                      <template v-slot:placeholder>
                                        <v-row class="fill-height ma-0" align="center" justify="center">
                                          <v-progress-circular indeterminate color="#ff770f70"></v-progress-circular>
                                        </v-row>
                                      </template>
                                    </v-img> -->
															<v-img
																width="100%"
																height="221px"
																max-height="221px"
																v-if="img.url != undefined"
																:src="img.url"
															>
																<template v-slot:placeholder>
																	<v-row
																		class="fill-height ma-0"
																		align="center"
																		justify="center"
																	>
																		<v-progress-circular
																			indeterminate
																			color="#ff770f70"
																		></v-progress-circular>
																	</v-row>
																</template>
															</v-img>
														</v-col>
													</v-row>
												</v-sheet>
											</v-carousel-item>
										</v-carousel>
										<v-card-title>
											{{ s.title }}
											<small>{{ s.short_description }}</small>
										</v-card-title>
										<v-card-text>
											{{ s.description }}
										</v-card-text>
										<v-card-actions> </v-card-actions>
									</v-card>
								</v-col>
							</v-row>
						</v-tab-item>
					</v-tabs-items>
				</v-row>
			</v-col>
		</v-row>

		<v-row class="footerBeneficius padMb" v-if="intBreakPoint >= 2">
			<v-col cols="12" md="4">
				<img src="../assets/beneficius/logobranco.png" alt="" />
				<p
					class="mt-10"
					style="font-family: raleway; font-weight: 300; color: #fff"
				>
					O clube de vantagens oficial da Ribus para Tokenistas.
				</p>
				<div>
					<a href="https://www.facebook.com/ribusdigital/" target="_blank">
						<v-icon color="#fff" size="30" style="margin: 0 5px"
							>mdi-facebook</v-icon
						>
					</a>
					<a href="https://www.instagram.com/ribusdigital/" target="_blank">
						<v-icon color="#fff" size="30" style="margin: 0 5px"
							>mdi-instagram</v-icon
						>
					</a>
					<a
						href="https://www.linkedin.com/company/ribus-tecnologia/"
						target="_blank"
					>
						<v-icon color="#fff" size="30" style="margin: 0 5px"
							>mdi-linkedin</v-icon
						>
					</a>
				</div>
			</v-col>
			<v-col cols="6" md="4">
				<h3 style="font-family: raleway; font-weight: 500; color: #fff">
					Mapa do site
				</h3>

				<a href="/beneficius" style="color: #fff; text-decoration: none">
					<p
						class="mt-10"
						style="
							font-family: raleway;
							font-weight: 300;
							color: #fff;
							margin: 5px 0;
						"
					>
						Home
					</p>
				</a>
				<a href="#sobre" style="color: #fff; text-decoration: none">
					<p
						style="
							font-family: raleway;
							font-weight: 300;
							color: #fff;
							margin: 5px 0;
						"
					>
						Sobre nós
					</p>
				</a>

				<a href="#ajuda" style="color: #fff; text-decoration: none">
					<p
						style="
							font-family: raleway;
							font-weight: 300;
							color: #fff;
							margin: 5px 0;
						"
					>
						Ajuda
					</p>
				</a>

				<a
					href="https://ribus.com.br/docs/Politica-de-Privacidade.pdf"
					target="_blank"
					style="color: #fff; text-decoration: none"
				>
					<p
						style="
							font-family: raleway;
							font-weight: 300;
							color: #fff;
							margin: 5px 0;
						"
					>
						Política de privacidade
					</p>
				</a>
			</v-col>
			<v-col cols="6" md="4">
				<h3 style="font-family: raleway; font-weight: 500; color: #fff">
					Nossos serviços
				</h3>
				<a href="/beneficius" style="color: #fff; text-decoration: none">
					<p
						class="mt-10"
						style="
							font-family: raleway;
							font-weight: 300;
							color: #fff;
							margin: 5px 0;
						"
					>
						Home
					</p>
				</a>
				<a
					href="/beneficiusParceiros"
					style="color: #fff; text-decoration: none"
				>
					<p
						style="
							font-family: raleway;
							font-weight: 300;
							color: #fff;
							margin: 5px 0;
						"
					>
						Parceiros
					</p>
				</a>
				<a
					href="/beneficiusHospedagens"
					style="color: #fff; text-decoration: none"
				>
					<p
						style="
							font-family: raleway;
							font-weight: 300;
							color: #fff;
							margin: 5px 0;
						"
					>
						Hospedagem
					</p>
				</a>
				<a href="tel:+552199999999" style="color: #fff; text-decoration: none">
					<p
						style="
							font-family: raleway;
							font-weight: 300;
							color: #fff;
							margin: 5px 0;
						"
					>
						<v-icon color="white">mdi-book</v-icon>
						+55 21 9999-9999
					</p>
				</a>
				<a
					href="mailto:contato@beneficiuscombr"
					style="color: #fff; text-decoration: none"
				>
					<p
						style="
							font-family: raleway;
							font-weight: 300;
							color: #fff;
							margin: 5px 0;
						"
					>
						<v-icon color="white">mdi-at</v-icon>
						contato@beneficiuscombr
					</p>
				</a>
			</v-col>
		</v-row>

	</v-container>
</template>

<style scoped>
	@media (min-device-width: 300px) and (max-device-width: 855px) {
		.flexMobile {
			flex-direction: column !important;
		}

		.padTab {
			padding: 10px 0 !important;
		}
		.sizeMob {
			width: 100% !important;
		}

		.padMob {
			padding: 0 10px !important;
		}
	}
	.footerBeneficius {
		background-color: #042d4c;
		padding: 50px;
	}
	.etiqueta {
		background-color: #28e78e;
		padding: 4px 8px;
		border-radius: 16px;
		/* height: 30px; */
		/* width: 193px; */
		margin: 11px 0;
	}

	.historyMenu {
		font-family: raleway;
		color: #042d4c;
		font-weight: 500;
	}
	.btnMenu {
		background-color: transparent !important;
		box-shadow: none !important;
		color: #4d6a80 !important;
	}
</style>

<script>
	export default {
		data: () => ({
			selectedItem: 1,

			items: ["Imóveis", "Cursos", "Serviços"],

			// items3: [
			// 	{ text: "+55 21 9999-9999", icon: "mdi-whatsapp" },
			// 	{ text: "+55 21 9999-9999", icon: "mdi-phone-dial-outline" },
			// 	{ text: "contato@vcadvogados.com.br", icon: "mdi-at" },
			// ],
			produtos: [],
			servicos: [],
			tab: 2,
		}),

		computed: {
			haveSocialMedia() {
				if (
					this.parceiro.infos !== null &&
					this.parceiro.infos.social !== undefined
				) {
					return (
						[undefined, ""].indexOf(this.parceiro.infos.social.ig) === -1 ||
						[undefined, ""].indexOf(this.parceiro.infos.social.fb) === -1 ||
						[undefined, ""].indexOf(this.parceiro.infos.social.linkedin) === -1
					);
				} else {
					return false;
				}
			},
			getSite() {
				if (this.parceiro.infos.social.length > 0) {
					return this.parceiro.infos.social.site.indexOf("https://") > -1 ||
						this.parceiro.infos.social.site.indexOf("http://") > -1
						? this.parceiro.infos.social.site
						: "https://" + this.parceiro.infos.social.site;
				} else {
					return null;
				}
			},
			getInstagram() {
				if (this.parceiro.infos.social.length > 0) {
					return this.parceiro.infos.social.ig.indexOf("https://") === 0 ||
						this.parceiro.infos.social.ig.indexOf("http://") === 0
						? this.parceiro.infos.social.ig
						: "https://instagram.com/" +
								this.parceiro.infos.social.ig.replace("@", "");
				} else {
					return "";
				}
			},
		},

		metaInfo() {
			return {
				title: this.parceiro != undefined ? this.parceiro.name : "Parceiro",
			};
		},
		mounted() {
			window.scrollTo(0, 0);

			if (this.$route.params.idParceiro) {
				let tmpParceiro = this.$store.getters.parceiroById(
					this.$route.params.idParceiro
				);
				if (tmpParceiro) {
					tmpParceiro.infos =
						typeof tmpParceiro.infos === undefined
							? { social: {} }
							: typeof tmpParceiro.infos !== "object"
							? JSON.parse(tmpParceiro.infos)
							: tmpParceiro.infos;
					this.parceiro = tmpParceiro;
				}
			}
		},
		watch: {
			parceiro: function (nValue) {
				if (nValue) {
					this.$http
						.get("/products?type=PROPERTY&user_id=" + nValue.id)
						.then((res) => {
							this.produtos = res.data.result.products;
						});
					this.$http
						.get("/products?type[]=PHYSICAL_PRODUCT&user_id=" + nValue.id)
						.then((res) => {
							this.servicos = res.data.result.products;
						});
				}
			},
			"$store.state.parceiros": {
				handler: function () {
					this.parceiro = this.$store.getters.parceiroById(
						this.$route.params.idParceiro
					);
				},
				deep: true,
				immediate: true,
			},
		},

		methods: {
			sanitizeTitle: function (title) {
				var slug = "";
				// Change to lower case
				var titleLower = title.toLowerCase();
				// Letter "e"
				slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
				// Letter "a"
				slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
				// Letter "o"
				slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
				// Letter "u"
				slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
				// Letter "d"
				slug = slug.replace(/đ/gi, "d");
				// Trim the last whitespace
				slug = slug.replace(/\s*$/g, "");
				// Change whitespace to "-"
				slug = slug.replace(/\s+/g, "-");

				return slug;
			},
		},
	};
</script>
